import { BCMSStateManagerCRUD, useModel } from "bcms-react";
import LoginPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/LoginPage";

export default function CaptureUserIDentered(props) {
    // initalize a new BCMSStateManagerCRUD instance using the default page data
    // updating the modal property
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .update([ "userID" ], "georgew")
    .submit();

    return <LoginPage data={ data } />
}
